// extracted by mini-css-extract-plugin
export var cardHeader = "_sb-0";
export var reorderHandle = "_sb-3";
export var titleArea = "_sb-1";
export var titleAreaWithHandle = "_sb-2";